import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import Typography from "@mui/material/Typography";
import { CsValueDebugDisplay, useShowDebugValues, } from "@plansoft-configuration-renderer/debug";
import { TextMode, useConfigurationAttributeName, useConfigurationCurrencies, useConfigurationLanguage, useConfigurationValueDescription, useConfigurationValueLabel, useConfigurationValueName, useCsValue, } from "@plansoft-configuration-renderer/framework";
import { MarkdownOrText } from "../Common/MarkdownOrText";
import { ConfigurationValueInfo } from "../Info";
import { ValueOptionPrice } from "./ValueOptionPrice";
import { ValueQuantity } from "./ValueQuantity";
import { ValueSuggestion } from "./ValueSuggestion";
export function ValueContentEmpty() {
    return _jsx(Fragment, {});
}
export function ValueContentValue(props) {
    const { textMode = TextMode.PlainText } = props;
    const text = useConfigurationValueLabel();
    return _jsx(MarkdownOrText, { text: text, textMode: textMode });
}
export function ValueContentName(props) {
    const { textMode = TextMode.PlainText } = props;
    const text = useConfigurationValueName();
    return _jsx(MarkdownOrText, { text: text, textMode: textMode });
}
export function ValueContentAttributeName(props) {
    const { textMode = TextMode.PlainText } = props;
    const text = useConfigurationAttributeName();
    return _jsx(MarkdownOrText, { text: text, textMode: textMode });
}
export function ValueContentDescription(props) {
    const { textMode = TextMode.Markdown } = props;
    const text = useConfigurationValueDescription();
    return _jsx(MarkdownOrText, { text: text, textMode: textMode });
}
/**
 * Debug component
 * @returns
 */
export function ValueContentDebug() {
    const value = useCsValue();
    const showDebug = useShowDebugValues();
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    return _jsx(CsValueDebugDisplay, { value: value });
}
export function ValueContentSuggestion() {
    const value = useCsValue();
    return _jsx(ValueSuggestion, { value: value });
}
export function ValueContentHelp(props) {
    const { textMode = TextMode.Markdown, overlayMode } = props;
    return (_jsx(ConfigurationValueInfo, { textMode: textMode, overlayMode: overlayMode }));
}
export function ValueContentTypeCode() {
    const value = useCsValue();
    return _jsx(Typography, { component: "span", children: value.typeCodeFragment });
}
/**
 * Property `partId` from value
 * @returns
 */
export function ValueContentItemNo() {
    const value = useCsValue();
    return _jsx(Typography, { children: value.partId });
}
/**
 * Quantity selector
 * @returns
 */
export function ValueContentQuantity() {
    return _jsx(ValueQuantity, {});
}
export function ValueContentPrice() {
    const value = useCsValue();
    const localeCode = useConfigurationLanguage();
    const currencies = useConfigurationCurrencies();
    if (value.price == null) {
        return _jsx(Fragment, {});
    }
    if (value.priceUnitId == null) {
        return _jsx(Fragment, {});
    }
    const currency = currencies[value.priceUnitId];
    if (currency == null) {
        return _jsx(Fragment, {});
    }
    return (_jsx(ValueOptionPrice, { price: value.price, locale: localeCode, currencyInfo: currency }));
}
//# sourceMappingURL=ValueContent.js.map